<div class="page-holder">

    <div class="title-holder">
        <div class="center-content">
   
            <div class="text-holder">
                <h2 class="title uppercase">Już wkrótce udostępnimy
                    nasze nowe aplikacje
                    na systemy Android i iOS!</h2>
                    <p>
                Pracujemy intensywnie nad tym,
                aby zapewnić Wam jeszcze lepsze
                doświadczenie, większą wygodę
                oraz nowe funkcjonalności.
                <br /><br />
                Do tego czasu prosimy o korzystanie
                z tradycyjnych kart.
                <br /><br />
                Dziękujemy za cierpliwość – zostańcie z nami, premiera już niedługo!
                </p>
            </div>
                     <div class="image-holder">
                <img src="/assets/images/app.png" alt="Aplikacja Mobilna ZGrane Grono">
            </div>

        </div>
    </div>


</div>